import {
  createContext,
  useContext,
  useState,
  FC,
  useEffect,
  ReactNode,
} from "react";
import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";

import { IAutoCompleted } from "../../types/ProdutoresContext.Types";

import {
  IListBordero,
  IListContratos,
  ICreateContrato,
  IContextContrato,
  IGetByIdContratos,
  ICancelarContrato,
  IListContractsFiles,
  IValuesFilterBordero,
  ICreateBorderoParcela,
  IValuesFilterContrato,
  IValueContractInternal,
  ICreateNovaParcelaBordero,
  ICreateEditarParcelaBordero,
  IValueComissaoCorretorGrade,
  IValueComissaoCorretoraGrade,
  IValuesTypesUploadCommission,
} from "./ContratosTypes";
import {
  valueDefaultInputBorderoParcelas,
  valuesDefaultFilterContrato,
  valueDefaultInputContratos,
  valuesDefaultFilterBordero,
} from "./valuesDefaultInputsContratos/ValueDefaultInputContratos";
import moment from "moment";
import { IListPDF } from "src/Pages/components/DropZoneCore/DropZoneCore";

const ContratosContext = createContext({} as IContextContrato);

export const ContratoContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [listContratos, setListContratos] = useState([] as IListContratos[]);
  const [listBordero, setListBordero] = useState<IListBordero>({
    data: [],
    metrics: { recebidas: { quantidade: 0, valor: 0 }, vencidas: { quantidade: 0, valor: 0 }, pendentes: { quantidade: 0, valor: 0 } }
  });

  const [dataGetByIdContrato, setDataGetByIdContrato] =
    useState<IGetByIdContratos>();

  const [valuesInputCancelarContrato, setValuesInputCancelarContrato] =
    useState<ICancelarContrato>({
      date: `${GetDateUSSemValue()}`,
      description: "",
      status: "APPROVED",
    });

  const [valuesInputEditarParcelaBordero, setValuesInputEditarParcelaBordero] =
    useState<ICreateEditarParcelaBordero>();

  const [valuesInputNovaParcelaBordero, setValuesInputNovaParcelaBordero] =
    useState<ICreateNovaParcelaBordero>();

  const [valueAutoCompProdutorAll, setValueAutoCompProdutorAll] =
    useState<IAutoCompleted>({ label: "", id: "" });

  const [valueComissaoCorretoraGrade, setValueComissaoCorretoraGrade] =
    useState<IValueComissaoCorretoraGrade>();

  const [valueComissaoProdutorGrade, setValueComissaoProdutorGrade] =
    useState<IValueComissaoCorretorGrade>();

  const [valueContractInternal, setValueContractInternal] =
    useState<IValueContractInternal>();

  const [valuesInputsContrato, setValuesInputsContrato] =
    useState<ICreateContrato>({ ...valueDefaultInputContratos });

  const [valuesFilterContrato, setValuesFilterContrato] =
    useState<IValuesFilterContrato>(valuesDefaultFilterContrato);

  const [valuesFilterBordero, setValuesFilterBordero] =
    useState<IValuesFilterBordero>(valuesDefaultFilterBordero);



  const [valuesTypesUploadCommission, setValuesTypesUploadCommission] =
    useState<IValuesTypesUploadCommission[]>([]);

  const [valuesInputsBorderoParcela, setValuesInputsBorderoParcela] =
    useState<ICreateBorderoParcela>({ ...valueDefaultInputBorderoParcelas });

  const [orderTable, setOrderTable] = useState<"asc" | "desc">(() => {
    const order = localStorage.getItem("orderParcelasBrokeris");

    if (order) {
      return order as "asc" | "desc";
    }
    return "asc";
  });

  const [listContractsFiles, setListContractsFiles] = useState<
    IListContractsFiles[]
  >([]);

  const [uploadFiles, setUploadFiles] = useState<IListPDF[]>([]);


  useEffect(() => {
    setValuesFilterContrato((prevValue) => ({
      ...prevValue,
      endDateSignature: valuesFilterContrato.startDateSignature,
    }));
  }, [valuesFilterContrato.startDateSignature]);

  useEffect(() => {
    setValuesFilterContrato((prevValue) => ({
      ...prevValue,
      endEffectiveDate: valuesFilterContrato.startEffectiveDate,
    }));
  }, [valuesFilterContrato.startEffectiveDate]);

  useEffect(() => {
    setValuesFilterContrato((prevValue) => ({
      ...prevValue,
      endDateEmission: valuesFilterContrato.startDateEmission,
    }));
  }, [valuesFilterContrato.startDateEmission]);

  useEffect(() => {
    setValuesInputsContrato((prevValue) => ({
      ...prevValue,
      vencimento_data_2: `${moment(prevValue.vencimento_data)
        .add(1, "month")
        .format("YYYY-MM-DD")}`,
    }));
  }, [valuesInputsContrato.vencimento_data]);

  useEffect(() => {
    localStorage.setItem("orderParcelasBrokeris", orderTable);
  }, [orderTable]);

  return (
    <ContratosContext.Provider
      value={{
        setValuesInputEditarParcelaBordero,
        setValuesInputNovaParcelaBordero,
        valuesInputEditarParcelaBordero,
        setValueComissaoCorretoraGrade,
        setValuesInputCancelarContrato,
        setValueComissaoProdutorGrade,
        setValuesInputsBorderoParcela,
        setValuesTypesUploadCommission,
        valuesInputNovaParcelaBordero,
        valuesInputCancelarContrato,
        valueComissaoCorretoraGrade,
        setValueAutoCompProdutorAll,
        valuesTypesUploadCommission,
        valueComissaoProdutorGrade,
        valuesInputsBorderoParcela,
        valueAutoCompProdutorAll,
        setValueContractInternal,
        setValuesInputsContrato,
        setValuesFilterContrato,
        setDataGetByIdContrato,
        setValuesFilterBordero,
        valueContractInternal,
        setListContractsFiles,
        valuesInputsContrato,
        valuesFilterContrato,
        valuesFilterBordero,
        dataGetByIdContrato,
        listContractsFiles,
        setListContratos,
        setUploadFiles,
        setListBordero,
        listContratos,
        listBordero,
        uploadFiles,
        setOrderTable,
        orderTable,
      }}
    >
      {children}
    </ContratosContext.Provider>
  );
};

export const useContextContrato = (): IContextContrato =>
  useContext(ContratosContext);
